/* tslint:disable */
/* eslint-disable */
/* @relayHash c3295854cdf2fbf989a53e1150acb507 */

import { ConcreteRequest } from "relay-runtime";
export type TransactionVerifyEmailMutationInput = {
    emailVerificationToken: string;
    clientMutationId?: string | null;
};
export type verifyEmailHandlerMutationVariables = {
    input: TransactionVerifyEmailMutationInput;
};
export type verifyEmailHandlerMutationResponse = {
    readonly transactionVerifyEmail: {
        readonly __typename: string;
    } | null;
};
export type verifyEmailHandlerMutation = {
    readonly response: verifyEmailHandlerMutationResponse;
    readonly variables: verifyEmailHandlerMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "TransactionVerifyEmailMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "transactionVerifyEmail",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TransactionVerifyEmailMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "verifyEmailHandlerMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "verifyEmailHandlerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "verifyEmailHandlerMutation",
    "id": "ferrum/262.0.0-2020-04-28T16:33:21.478Z/verifyEmailHandlerMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '038df1e8cb2211f8d718a9b6dd594b40';
export default node;
